import { defineComponent as s, openBlock as t, createElementBlock as o, createElementVNode as l, Fragment as a, renderList as n, createBlock as d } from "vue";
import i from "./ProductVariantCard.js";
import { _ as u } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './css/ProductVariantSelector.css';const m = { class: "product-variant-selector" }, p = { class: "selector-scroll" }, _ = /* @__PURE__ */ s({
  __name: "ProductVariantSelector",
  props: {
    /**
     * Array of variant objects to display
     */
    variants: {
      type: Array,
      required: !0
    },
    /**
     * Currently selected variant src (v-model)
     */
    modelValue: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(r) {
    return (c, f) => (t(), o("div", m, [
      l("div", p, [
        (t(!0), o(a, null, n(r.variants, (e) => (t(), d(i, {
          key: e.src,
          shortcode: e.shortcode,
          subline: e.subline,
          price: e.price,
          "is-active": r.modelValue === e.src,
          onSelect: (V) => c.$emit("update:modelValue", e.src)
        }, null, 8, ["shortcode", "subline", "price", "is-active", "onSelect"]))), 128))
      ])
    ]));
  }
}), k = /* @__PURE__ */ u(_, [["__scopeId", "data-v-5b4b1476"]]);
export {
  k as default
};
